module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAAAXNSR0IArs4c6QAAAIZJREFUGBljYCAMGKVsb/tLm9+WQVbKhMzBzm5gZGZgCmBkZ94sanpVAqaGEcYgRMvY3J3DwMSo/fP798DXp7VfMMra3bL7/485jIHx/3+cmhmZ/gGlWYHyyf8ZGS7+/P7DjwinYjeObKcSYWMDk6zt3flA/xnD/IfdDZii4OiQsrsjiywFAOm2Lznx1/jtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow blue.png
// module id = 38
// module chunks = 0